import { Component } from "@angular/core";

@Component({
  template: ` <div class="container p-3">
    <h2 class="h2 mt-4">{{ "not_found_title" | translate }}</h2>
    <p>{{ "not_found_text" | translate }}</p>
  </div>`,
})
export class NotFoundPage {}
